import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import store from "./store";
import router from "./router";
import audioManager from "./utils/audioManger.js";
import myUtils from "@/utils/Tool";
import showVipPopup from "./utils/showVip";
import "../autoSize";
import LoadImage from "@/utils/loadImage";
const config = require("./settings");
Vue.prototype.$audioManager = audioManager;
Vue.prototype.$utils = myUtils;
Vue.prototype.$config = config;
Vue.prototype.$showVip = showVipPopup;
Vue.config.devtools = true;
Vue.use(ElementUI, { locale });
Vue.directive("img", LoadImage);
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
